import { render, staticRenderFns } from "./menuItemTag.vue?vue&type=template&id=1bc7eb99&scoped=true&"
import script from "./menuItemTag.vue?vue&type=script&lang=js&"
export * from "./menuItemTag.vue?vue&type=script&lang=js&"
import style0 from "./menuItemTag.vue?vue&type=style&index=0&id=1bc7eb99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7eb99",
  null
  
)

export default component.exports